module.exports = __webpack_public_path__ + "static/media/onemobile.a17d884b.svg";